/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
import { createUseGlobalVariants } from "@plasmicapp/react-web";

export const _useGlobalVariants = createUseGlobalVariants({});
